"use client";

import { Modal } from "@/components/Modal";
import { DowngradeButtons } from "@/components/pricing/pricingButton/downgradeSubscriptionModal/DowngradeButtons";
import { ResourceCards } from "@/components/pricing/pricingButton/downgradeSubscriptionModal/ResourceCards";
import { NormalText } from "@/components/text/NormalText";
import { User, UserNoDates } from "@/types/types";

export function DowngradeSubscriptionModal({
  open,
  closeModal,
  user,
  numberOfModels,
  downgradeStripeSubscriptionId,
}: {
  open: boolean;
  closeModal: () => void;
  user: UserNoDates | null;
  numberOfModels: number;
  downgradeStripeSubscriptionId: User["stripeSubscriptionId"];
}) {
  // Should never happen
  if (downgradeStripeSubscriptionId === null || user === null) {
    return null;
  }

  return (
    <Modal
      open={open}
      closeModal={closeModal}
      title="Downgrade"
      widthMode="normal"
    >
      <NormalText elementType="p" className="mb-6">
        When downgrading, your conversion time will be reset to the new plan's
        limit.
      </NormalText>
      <ResourceCards
        user={user}
        numberOfModels={numberOfModels}
        downgradeStripeSubscriptionId={downgradeStripeSubscriptionId}
        className="mb-6"
      />
      <NormalText elementType="p" className="mb-4">
        Are you sure you want to downgrade your subscription?
      </NormalText>
      <DowngradeButtons
        closeModal={closeModal}
        downgradeStripeSubscriptionId={downgradeStripeSubscriptionId}
      />
    </Modal>
  );
}
